import {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import contact from '../assets/imgs/contact-us.png';
import { toast } from 'sonner';
import { FaUser, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import LoadingButton from './utils/Loading';

const Contact = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    useEffect(() => {
        AOS.init({
            duration: 1500,
            once: true,
        });
    },[]);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    toast.info("Sending message... the server might take a few seconds to respond.");
    fetch("https://portfolio-backend-te16.onrender.com/send-email", {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name,
            email,
            message,
        }),
    })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message);
      }

      return data;
    })
    .then(() => {
        setName("");
        setEmail("");
        setMessage("");
        toast.success("Message sent successfully!")
        setLoading(false);
    })
    .catch((err) => {
      console.error(err);
      toast.error(err.message);
      setLoading(false);
    });
  };

    return (
    <section className="section mb-0" id="contact">
        <div className="container">
            <div className='text-center mb-5'>
                <p className="section-subtitle"  data-aos="fade-left">How can you communicate?</p>
                <h6 className="section-title" data-aos="fade-left">Contact Me</h6>
            </div>
            <div className="row align-items-center" >
                <div className="col-md-6 contact-img"  data-aos="fade-right">
                    <img src={contact} className='img-fluid' width={500} alt="contact" />
                </div>
                <div className="col-md-6 form-content" data-aos="fade-left">
                  <div className='card border-0 rounded p-4'>
                    <form onSubmit={handleSubmit}>
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-primary text-white">
                          <FaUser />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Your Name"
                          required
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>

                      {/* Email Input */}
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-primary text-white">
                          <FaEnvelope />
                        </span>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>

                      {/* Message Input */}
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-primary text-white">
                          <FaPaperPlane />
                        </span>
                        <textarea
                          rows="5"
                          className="form-control"
                          placeholder="Write Something..."
                          required
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        ></textarea>
                      </div>

                      {/* Submit Button */}
                      <div className="text-center">
                        <LoadingButton
                          isLoading={loading} 
                          type="submit" 
                          className="btn btn-primary px-4 rounded-pill shadow"
                        >
                          Send Message
                        </LoadingButton>
                      </div>  
                    </form>
                    <div className="mt-4 text-muted">
                        <p><FaMapMarkerAlt className="text-primary" />&nbsp; Pandiya Khedi Maxi Road Ujjain, MP</p>
                        <p><FaPhoneAlt className="text-primary" />&nbsp; +91 8982896759</p>
                        <p><FaEnvelope className="text-primary" />&nbsp; javedshikh312@gmail.com</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </section>
    );
}

export default Contact ;